<template>
  <div class="c-add-note">
    <p class="c-add-note__remaining">{{ formValue.noteValue.length }}/200</p>
    <div class="c-add-note__note">
      <n-form :label-width="80" :model="formValue" :rules="rules" ref="formRef" label-placement="top">
        <n-grid :cols="12" :x-gap="20">
          <n-form-item-gi :span="12" :label="$t('myMusic.noteContent')" path="noteValue">
            <n-input type="textarea" v-model:value="formValue.noteValue" :rows="10"
              :placeholder="`${$t('myMusic.editNote')} ...`" @keydown.stop />
          </n-form-item-gi>
        </n-grid>
      </n-form>
    </div>

    <div class="submit">
      <mi-button @click="submit" :isLoading="isLoading"> {{ $t('myMusic.submitSave') }} </mi-button>
    </div>
  </div>
</template>
<script>
import {
  defineComponent, ref, watch, onMounted, inject,
} from 'vue';
import {
  NInput, useMessage, NForm, NFormItemGi, NGrid,
} from 'naive-ui';
// usePopInfo as naiveMessage
import { useI18n } from 'vue-i18n';
import MiButton from '@/components/Global/MiButton.vue';
import { updateAccountNoteAPI } from '@/api/myMusicNotes';
import useRequest from '@/hooks/useRequest';
import errMsg from '@/utils/errorMessage';

export default defineComponent({
  name: 'EditNote',
  components: {
    NInput,
    MiButton,

    NForm,
    NFormItemGi,
    NGrid,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    noteData: {
      type: Object,
      default: () => ({}),
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['close'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const message = useMessage();
    const formRef = ref(null);
    const formValue = ref({
      noteValue: props.noteData.content || '',
    });

    const { request, response, isLoading } = useRequest(updateAccountNoteAPI);

    const submit = async () => {
      const errorExist = await formRef.value.validate();
      if (!errorExist) {
        request({
          in: {
            content: formValue.value.noteValue,
            accountNoteContentUid: props.noteData.accountNoteContentUid,
          },
        });
      }
    };

    onMounted(() => {
      formValue.value.noteValue = props.noteData.content;
    });

    const reloadNoteContentRequest = inject('reloadNoteContentRequest');

    watch(response, () => {
      const [err, res] = response.value;

      if (err) {
        message.error(err.toString());
        return;
      }

      if (res) {
        emit('close', false);
        message.success(t('msg.updateNoteSuccess'));
        reloadNoteContentRequest();
      }
    });

    return {
      formValue,
      formRef,
      submit,
      rules: {
        noteValue: [
          {
            required: true,
            message: errMsg.required('內容'),
            trigger: ['input'],
          },
          {
            required: true,
            message: errMsg.contactLimit200,
            trigger: ['input'],
            validator: () => formValue.value.noteValue.length <= 200,
          },
        ],
      },
      isLoading,
    };
  },
});
</script>
<style lang="scss" scoped>
.c-add-note {
  @include padding(0 24px);

  &__remaining {
    @include flex(flex-end);
    @include font-style($c-assist3, 12, 600, 0.6px, 18px);
  }

  &__note {
    margin-top: 6px;
  }
}

.submit {
  margin-top: 26px;
  @include flex(center);
}

.cancel {
  margin-top: 16px;
  @include flex(center);

  &__btn {
    cursor: pointer;
    @include font-style($c-assist3, 14, 600, 0.7px, 18px);
    border: 0px transparent;
    outline: 0px transparent;
    background-color: transparent;
  }
}
</style>

<style lang="scss"></style>
